import { FC } from 'react';
import { FormTextField } from 'components/shared/FormTextField';

export const SurveyLetterRegistrationAddress: FC = () => {
	return (
		<>
			<FormTextField name="adrr_street" label="Вулиця" />
			<FormTextField name="adrr_house" label="Будинок" />
			<FormTextField name="adrr_flat" label="Квартира" />
		</>
	);
};
